export default __webpack_public_path__ + "static/treatmentarea-stomachafter-1f54cb08ba6e27af576aa0fa4e0c56c1.webp";